import React from 'react';
import PropTypes from 'prop-types';
import { originalRefundSources, preselectedRefundPaymentMethod, refundPaymentMethodLabel } from './refundPaymentMethods';

const OriginalRefundSource = ({ detail, formik }) => {
 const sources=originalRefundSources(detail);
 if(sources.length < 2) return null;
 return <div className="mb-3">
  <label htmlFor="appointment-original-refund-source">Original payment method</label>
  <select id="appointment-original-refund-source" className="form-control" value={formik.values.refund_source || preselectedRefundPaymentMethod(detail)} disabled={formik.isSubmitting} onChange={event=>{
   const source=sources.find(row=>row.payment_method===event.target.value);
   if(!source) return;
   formik.setFieldValue('refund_source',source.payment_method);
   formik.setFieldValue('deposit_payment_by',source.payment_method);
   formik.setFieldValue('xero_line_allocations',[]);
  }}>
   {sources.map(source=><option key={source.payment_method} value={source.payment_method}>{refundPaymentMethodLabel(source.payment_method)} — {source.refundable_amount_minor!=null ? `Available ${(source.refundable_amount_minor/100).toFixed(2)}` : `Paid ${(source.paid_amount_minor/100).toFixed(2)}`}</option>)}
  </select>
  <p className="small text-muted">Refund each original payment method separately. The remaining refundable balance is verified when submitted.</p>
 </div>;
};
OriginalRefundSource.propTypes = {
 detail: PropTypes.object,
 formik: PropTypes.shape({
  values: PropTypes.shape({ refund_source: PropTypes.string }).isRequired,
  isSubmitting: PropTypes.bool,
  setFieldValue: PropTypes.func.isRequired,
 }).isRequired,
};
export default OriginalRefundSource;
